import { FontWeights, mergeStyleSets } from "@fluentui/react";

export const customerStyles = mergeStyleSets({
  buttonArea: {
    verticalAlign: "top",
    display: "inline-block",
    textAlign: "center",
    cursor: "pointer",
  },
  configArea: {
    display: "inline-block",
  },
  button: {
    background: "transparent",
    color: "#FFF",
    border: "0",
    height: "auto",
    ">span": {
      display: "flex",
      height: "60px",
      alignItems: "center",
      gap: "8px",
      justifyContent: "space-between",
      flexFlow: " row-reverse",
      i: {
        width: "28px",
        height: "28px",
        lineHeight: "28px"
      }
    }
  },
  callout: {
    width: 320,
    padding: "20px 24px",
    height: "calc(100vh - 100px)",
    top: "60px!important",
    right: "4px",
    left: "auto!important",
    background: "white"
  },
  title: {
    marginBottom: 12,
    fontWeight: FontWeights.semilight,
  },
  link: {
    display: "block",
    marginTop: 20,
  },
});
